/* eslint-disable import/no-unresolved */
import { ptBR } from "date-fns/locale";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import classNames from "react-day-picker/style.module.css";

// Calendário do CRONOGRAMA de UM projeto, ao lado da lista de eventos
// (D13 da parte 2, 03/09/2026 — "no painel do patrocinador, teremos a lista dos
// eventos, ter o cronograma ao lado").
//
// ♻️ O tema do react-day-picker vem do styled da aba "Cronograma" de nível 1
// (`../Calendar/styles`), não de uma cópia: são ~200 linhas com duas armadilhas
// medidas no navegador (as variáveis --rdp-* precisam ser declaradas em
// ".months", e --rdp-disabled-opacity precisa ser 1 no fundo escuro). Duplicar
// isso significaria descobrir as duas de novo na primeira manutenção.
import { Calendar as CalendarShell } from "../Calendar/styles";
import { buildCalendarModifiers } from "./calendarModifiers";

// `projectPeriod` é o início/fim do PROJETO (03/09/2026) — não é evento, vem do
// formulário base. Destacado como FAIXA roxa; sem ele, o calendário de um
// projeto sem eventos ficava totalmente apagado.
const ScheduleCalendar = ({ events = [], projectPeriod = null }) => {
  const { marks, ranges } = buildCalendarModifiers(events, projectPeriod);

  return (
    <CalendarShell>
      <DayPicker
        mode="multiple"
        selected={marks}
        min={marks.length}
        max={marks.length}
        // Os dias marcados não são clicáveis (é visualização, não seleção) —
        // mesma configuração do calendário de nível 1.
        disabled={[marks]}
        modifiers={{ in_project: ranges }}
        modifiersClassNames={{ in_project: "in_project" }}
        locale={ptBR}
        classNames={{
          ...classNames,
          months: "months",
          month: "month",
          selected: "selected",
          day: "day",
          day_button: "day_button",
          today: "today",
          weekdays: "weekdays",
          weekday: "weekday",
          button_next: "button_next",
          button_previous: "button_previous",
          caption_label: "caption_label",
          month_caption: "month_caption",
          nav: "nav",
        }}
      />
    </CalendarShell>
  );
};

export default ScheduleCalendar;
